export function isNonEmptyString(value: string | null | undefined): value is string {
  return value != null && value !== '';
}

export function isNonZero(value: number | null | undefined): value is number {
  return value != null && value !== 0;
}
